import type {
  HeaderLayoutContent,
  HeaderLayoutProps,
} from "scmp-app/components/header/layouts/types";
import {
  AbsoluteCenterFeatureContainer,
  ArticleSectionAllTabWrapper,
  DefaultLeftWrapper,
} from "scmp-app/components/header/styles";

type GetSectionLayoutProps = HeaderLayoutProps & {
  isSubSection: boolean;
  sectionId: string | string[] | undefined;
};

export const getSectionLayout = ({
  config,
  features,
  initEdition,
  isSubSection,
  sectionId,
}: GetSectionLayoutProps): HeaderLayoutContent => ({
  center: (
    <AbsoluteCenterFeatureContainer>
      {features.logoTextLink({
        showIn: "mobileUp",
      })}
    </AbsoluteCenterFeatureContainer>
  ),
  left: (
    <DefaultLeftWrapper>
      {features.hamburgerMenu({ showIn: "mobileAndTablet" })}
      {features.search({ showIn: "tabletUp" })}
      <ArticleSectionAllTabWrapper>
        {features.sectionEntityLink({
          isSubSection,
          sectionId,
          showIn: "desktopUp",
          size: "large",
        })}
        {features.oneLineMenu({
          appBarVariant: config?.appBarVariant,
          initEdition,
          isShowFullList: false,
          isShowPrefixHyphen: true,
          showIn: "desktopUp",
        })}
      </ArticleSectionAllTabWrapper>
    </DefaultLeftWrapper>
  ),
  right: (
    <>
      {features.subscription({
        showIn: "tabletUp",
      })}
      {features.dashboard({ showIn: "mobileUp" })}
    </>
  ),
});
